import React from 'react';
import { t } from 'i18next';
import { Lock2Line } from '@datanomik/core-ui/icons';

import { LabIcon } from './LabIcon';

export const LockPill: React.FC = () => (
  <Lock2Line
    aria-label={t('Blocked')}
    className="text-muted-foreground size-3.5 shrink-0 opacity-75"
  />
);

export const NewPill: React.FC = () => (
  <span className="bg-success-subtle text-success-subtle-foreground inline-flex h-4 shrink-0 items-center rounded-full px-1.5 text-[9px] font-semibold tracking-[0.04em] uppercase">
    {t('New')}
  </span>
);

export const BetaPill: React.FC = () => (
  <span
    title="Beta"
    aria-label="Beta"
    className="bg-warning-subtle text-warning-subtle-foreground flex size-5 shrink-0 items-center justify-center rounded-md text-[13px]"
  >
    <LabIcon />
  </span>
);

export const navPill = (entry: {
  locked?: boolean;
  isNew?: boolean;
  isBeta?: boolean;
}): React.ReactNode => {
  if (entry.locked) return <LockPill />;
  if (entry.isNew) return <NewPill />;
  if (entry.isBeta) return <BetaPill />;
  return null;
};
